module.exports = __webpack_public_path__ + "img/icon_jobfair_2.8709e2eb.png";